/**
 * 波形・試聴と同じ PCM を通常再生にも使う。圧縮音声を直接シークすると、
 * MP3 のフレーム索引などにより currentTime と実際の音声が一致しない。
 * Float32 WAV にすることで再量子化せず、HTMLAudioElement の音程保持も使える。
 */
export function audioBufferToWav(buffer: AudioBuffer): Blob {
	const { numberOfChannels, sampleRate, length } = buffer;
	const blockAlign = numberOfChannels * 4;
	const dataSize = length * blockAlign;
	const headerSize = 56;
	if (dataSize > 0xffffffff - (headerSize - 8)) {
		throw new RangeError("Audio exceeds the WAV size limit");
	}

	const wav = new ArrayBuffer(headerSize + dataSize);
	const view = new DataView(wav);
	const writeString = (offset: number, value: string) => {
		for (let i = 0; i < value.length; i++) {
			view.setUint8(offset + i, value.charCodeAt(i));
		}
	};
	writeString(0, "RIFF");
	view.setUint32(4, wav.byteLength - 8, true);
	writeString(8, "WAVE");
	writeString(12, "fmt ");
	view.setUint32(16, 16, true);
	view.setUint16(20, 3, true); // WAVE_FORMAT_IEEE_FLOAT
	view.setUint16(22, numberOfChannels, true);
	view.setUint32(24, sampleRate, true);
	view.setUint32(28, sampleRate * blockAlign, true);
	view.setUint16(32, blockAlign, true);
	view.setUint16(34, 32, true);
	writeString(36, "fact");
	view.setUint32(40, 4, true);
	view.setUint32(44, length, true);
	writeString(48, "data");
	view.setUint32(52, dataSize, true);

	for (let channel = 0; channel < numberOfChannels; channel++) {
		const samples = buffer.getChannelData(channel);
		for (let frame = 0; frame < length; frame++) {
			view.setFloat32(
				headerSize + frame * blockAlign + channel * 4,
				samples[frame],
				true,
			);
		}
	}
	return new Blob([wav], { type: "audio/wav" });
}
